import { SearchSuggestionsType } from '$util/types';
import { PreloadImage } from '$util/PreloadImage';
import Grid from '$components/layout/Grid';
import { nutHeaderSrc } from '$layout/partials/TopBackground';
import { Card } from '$components/basic/Card';
import { TextHighlight } from '$components/basic/TextHighlight';
import { SearchTopCard } from '$components/common/SearchTopCard';
import { Title } from '@/components/atoms/Title';
import { Styled } from './styled';

const { Row, Col } = Grid;

export function CarsTopSection() {
  return (
    <Styled className="CarsTopSection">
      <PreloadImage provider="cloudinary" href={nutHeaderSrc} displayFrom="lg" />

      <Row className="top-wrapper">
        <Col span={12}>
          <header>
            <Title h={1} size="xl">
              Every car <strong>make and model</strong>, covered
            </Title>
            <Title h={2} size="md">
              <span className="from-md">
                Thinking about your next car service?
                <br />
              </span>
              Get an instant quote from our selected garages
            </Title>
          </header>
          <Card className="search-card">
            <TextHighlight>What is your car make and/or model?</TextHighlight>
            <SearchTopCard id="CarsSearch" type={SearchSuggestionsType.CAR} />
          </Card>
        </Col>
      </Row>
    </Styled>
  );
}
CarsTopSection.displayName = 'CarsTopSection';

export default CarsTopSection;
